/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  // Bypasses IDB cache — used by the settings page for server-side paginated search.
  // Do NOT route this through CacheEnabledApiClient.get() (that path powers sidebar/filters).
  search({ q = '', page = 1, perPage = 100, sort = 'name_asc' } = {}) {
    return axios.get(this.url, {
      params: { q, page, per_page: perPage, sort },
    });
  }

  importCSV(formData) {
    return axios.post(`${this.url}/import`, formData);
  }
}

export default new LabelsAPI();
